// eslint-disable-next-line import/no-cycle
import axios from '@/core/plugins/axios';

const baseUrl = import.meta.env.VITE_API_TV_V2;
const headers = {
  'Content-Type': 'application/json; Charset=UTF-8',
};

export default {
  getOwners(options = null) {
    let params;

    if (options) {
      const {
        offset = 0,
        limit = 10,
        keyword = '',
        type = '',
        sort = '',
        language = '',
        country = ''
      } = options;

      params = {
        offset,
        fetchLimit: limit,
      };

      if (keyword !== '') params.search = keyword;
      if (language !== '') params.languageId = language;
      if (country !== '') params.countryId = country;
      if (type !== '') params.type = type;
      if (sort !== '') params.sort = sort;

      if (sort) {
        params.sortColumns = type;
        params.sortColumnOrders = sort;
      }
    }

    return axios({
      method: 'get',
      url: `${baseUrl}/owners`,
      headers,
      params,
    });
  },
  getOwnersList() {
    return axios({
      method: 'get',
      url: `${baseUrl}/owners`,
      headers,
    });
  },
  getOwner(id) {
    const params = {
      ownerId: id,
    };

    return axios({
      method: 'get',
      url: `${baseUrl}/owner`,
      headers,
      params,
    });
  },
  createOwner(data) {
    return axios({
      method: 'post',
      url: `${baseUrl}/owner`,
      headers,
      data,
    });
  },
  updateOwner(data) {
    return axios({
      method: 'put',
      url: `${baseUrl}/owner`,
      headers,
      data,
    });
  },
  deleteOwner(id) {
    const params = {
      ownerId: id,
    };

    return axios({
      method: 'delete',
      url: `${baseUrl}/owner`,
      headers,
      params,
    });
  },
};
